import { ValidationErrorEnum } from './ValidationErrorEnum';
import { ValidationError, WalletValidatorFunction } from './types';

/**
 * Validates city input
 * Allows: unicode letters (including accented), spaces, hyphens, periods, apostrophes (for names like O'Fallon, São Paulo)
 * Prevents: SQL injection and special characters
 * TODO: Consider adding minimum length validation (e.g., 2 characters)
 */
export const cityValidator: WalletValidatorFunction = (city: any) => {
  const errors: ValidationError[] = [];

  if (typeof city !== 'string') {
    errors.push(ValidationErrorEnum.STRING_ERROR_MESSAGE);
    return [false, errors];
  }

  // Allow unicode letters (including accented), spaces, hyphens, periods, apostrophes
  const cityRegex = /^[\p{L}\s\-.']+$/u;
  const isValid = cityRegex.test(city);

  if (!isValid) {
    errors.push(ValidationErrorEnum.INVALID_CITY);
  }

  return [errors.length === 0, errors];
};
